// Analytics tracking hook
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const trackEvent = async (eventType, data = {}) => {
  try {
    await fetch(`${API_URL}/api/admin/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: eventType,
        page: data.page || window.location.pathname,
        room_id: data.roomId || null,
        referrer: document.referrer || null
      })
    });
  } catch (error) {
    // Silently fail - analytics shouldn't break the site
    console.debug('Analytics tracking failed:', error);
  }
};

export const trackPageView = (page) => {
  trackEvent('page_view', { page });
};

export const trackBookingClick = () => {
  trackEvent('booking_click');
};

export const trackRoomView = (roomId) => {
  trackEvent('room_view', { roomId: String(roomId) });
};
